import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { PlannerStore } from '../../../store/Planner';
import { PlannerListDTO } from '../../../types';
import { Button, Modal, notification, NotificationType } from '@iba-team/portal-react-components/dist';
import { useLocalStorage } from 'react-use';

export interface DeleteListModalI{
  currentList: PlannerListDTO,
  setCurrentList: (value: Partial<PlannerListDTO>) => void,
  onDeleteList?: () => Promise<void>,
  clearPlannerList?: () => void,
  onClose?: ()=> void,
}

export const DeleteListModal = ({ setCurrentList, currentList, onDeleteList, onClose}: DeleteListModalI) => {
  const {t} = useTranslation();
  const {deletePlannerList, getPlannerFilters} = PlannerStore;
  const [storageAbsences, setStorageAbsences] = useLocalStorage('absenceList', '');
  const deleteList = async () => {
    try {
      await deletePlannerList(currentList.id);
      await getPlannerFilters();
      if(storageAbsences){
        const parsed = JSON.parse(storageAbsences);
        setStorageAbsences(JSON.stringify(parsed.filter((i: {  listName: string, listType: string, key: number}) => i.key !== currentList.id)));
      }

      notification.open({
        type: NotificationType.SUCCESS,
        title:  t('success'),
        description: t('listWasDeleted')
      });
    } catch (error) {
      notification.open({
        type: NotificationType.ERROR,
        title:  t('error'),
        description: t('listWasNotDeleted')
      });
    } finally {
      onClose?.();
    }
  };

  return(
    <Modal
      visible={true}
      className={'plannerModal'}
      onClose={()=> onClose?.()}
      titleText={t('deleteModalHeader')}
      footer={[
        <Button  theme={{variant: 'neutral', color: 'grey'}}  onClick={()=> onClose?.() }>
          { t('cancel') }
        </Button>,
        <Button theme={{variant: 'primary', color: 'red'}} onClick={()=> deleteList()} disabled={false}>
          {t('deleteListModalSubmit')}
        </Button>
      ]}>
      <div className={'deleteListModal'}>
        <div>
          <span>{t('deleteModalFirstCol')}</span>
          <span><b>{` «${currentList.name}»`}</b> ?</span>
        </div>
        <div>
          {t('deleteModalLastCol')}
        </div>
      </div>
    </Modal>
  );
};
